import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { useSettings } from "@/context/SettingsContext";

export default function FoundNewHome() {
  const { settings } = useSettings();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/archive").then((r) => setItems(r.data)); }, []);
  const cfg = settings?.archive || {};
  const empty = settings?.empty_states?.archive_empty || "No pieces have wandered on yet.";
  useEffect(() => { if (settings?.seo?.archive_title) document.title = settings.seo.archive_title; }, [settings]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-testid="archive-page">
      <div className="text-center mb-12">
        <p className="font-caption text-brass text-xs mb-2">The Ledger</p>
        <h1 className="font-display text-4xl sm:text-6xl text-gold" data-testid="archive-heading">
          {cfg.page_heading || "Found a New Home"}
        </h1>
        <p className="text-parchment/70 italic mt-4 max-w-2xl mx-auto">
          {cfg.intro || "A gentle archive of pieces already carried onward — kept here so their photographs may live on."}
        </p>
      </div>
      {items.length === 0 ? (
        <p className="text-center text-parchment/60 py-16">{empty}</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {items.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
